import React, { FC } from 'react'
import {
	formatDocumentSize,
	getFileNameAndExt,
} from '../../../../../lib/utils/formatDocument'
import {
	CurrentDocumentData,
	DocumentData,
} from '../../../../../lib/api/types/document.interfaces'
import { useUserDateFormat } from '../../../../../hooks/useUserDateFormat'

interface InfoTabProps {
	fileInfo: DocumentData | CurrentDocumentData | null
}

const InfoTab: FC<InfoTabProps> = ({ fileInfo }) => {
	const { formatDate } = useUserDateFormat()

	const items = [
		{
			name: 'Type',
			value: getFileNameAndExt(fileInfo?.name)?.ext?.toLocaleUpperCase() ?? '-',
		},
		{
			name: 'Size',
			value: fileInfo?.size ? formatDocumentSize(fileInfo?.size) : '-',
		},
		{
			name: 'Owner',
			value: fileInfo?.createdBy?.name,
		},
		{
			name: 'Created',
			value: fileInfo?.createdAt ? formatDate(fileInfo.createdAt) : '-',
		},
		{
			name: 'Modified',
			value: fileInfo?.modifiedAt ? formatDate(fileInfo.modifiedAt) : '-',
		},
		{
			name: 'Version',
			value: fileInfo?.version,
		},
		{
			name: 'Object ID',
			value: fileInfo?.id,
		},
	]

	return (
		<div className="border border-stroke-light dark:border-stroke-light-dark  rounded-lg overflow-hidden flex shadow-lg">
			<div className="flex flex-col min-w-20 w-fit border-r border-stroke-light dark:border-stroke-light-dark">
				{items?.map((item, index) => (
					<div
						key={index}
						className="px-3 border-b border-stroke-light dark:border-stroke-light-dark last:border-b-0 h-12 box-border flex items-center justify-start"
					>
						<p className="text-text-main dark:text-text-main-dark text-sm whitespace-nowrap font-bold">
							{item?.name}
						</p>
					</div>
				))}
			</div>
			<div className="flex flex-col flex-1">
				{items?.map((item, index) => (
					<div
						key={index}
						className="px-3 border-b border-stroke-light dark:border-stroke-light-dark last:border-b-0 h-12 box-border flex items-center justify-start"
					>
						<p className="text-text-main dark:text-text-main-dark text-lg">
							{item?.value || '-'}
						</p>
					</div>
				))}
			</div>
		</div>
	)
}

export default InfoTab
